module.exports = __webpack_public_path__ + "img/9788936456313.4d258ca0.jpg";